import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const LogOutIcon = ({
  width = 12,
  height = 12,
  stroke = '#25282B',
  strokeWidth = 1.5,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 12 12"
  >
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M4.5 10.544h-2c-.265 0-.52-.102-.707-.284-.188-.182-.293-.429-.293-.686V2.786c0-.257.105-.503.293-.685.187-.182.442-.284.707-.284h2M8 8.604l2.5-2.424L8 3.756M10.5 6.18h-6"
    />
  </svg>
);
